module.exports = __webpack_public_path__ + "img/sc.e6584421.svg";